/* Spanish catalog mirroring locale-autopilot-sales-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'ap.agent.sales.title': 'Facturas y presupuestos',
  'ap.agent.sales.pending': '{{count}} documentos no se han enviado.',
  'ap.agent.sales.detail': 'Envía las facturas y los presupuestos completados. Termina los borradores en la lista de facturas.',
  'ap.agent.sales.draft': 'Borrador',
  'ap.agent.sales.invoices': 'Facturas',
  'ap.agent.sales.drafts': 'Borradores',
  'ap.agent.sales.offers': 'Presupuestos',
  'ap.agent.offer.sendSelected': 'Enviar {{count}} presupuestos seleccionados',
  'ap.agent.sales.sentCount': '{{count}} presupuestos enviados',
  'ap.agent.sales.send': 'Enviar',
  'ap.agent.sales.open': 'Abrir',
  'ap.agent.sales.empty': 'No hay documentos sin enviar en esta lista.',
  'ap.agent.sales.unavailable': 'No se puede enviar el documento. Abre la lista de facturas para comprobar su estado.',
  'ap.agent.sales.emailMissing': 'El cliente no tiene correo electrónico. Añádelo en la lista de facturas antes de enviar.',
  'ap.agent.sales.sendFailed': 'El documento no se envió. Inténtalo de nuevo desde la lista de facturas.',
});
